import { translations } from 'locales/i18n';
import * as yup from 'yup';

export const ioUserValidationSchema = t =>
  yup.object().shape({
    email: yup.string().email().required(t(translations.validation.required())),
    firstName: yup.string().required(t(translations.validation.required())),
    lastName: yup.string().required(t(translations.validation.required())),
    homeUniversity: yup.string().required(t(translations.validation.required())),
    courseOfStudies: yup.string().required(t(translations.validation.required())),
    semester: yup.number().required(t(translations.validation.required()))
  });
